import React, {useState } from 'react';
import {Table, Spinner, Button } from 'react-bootstrap';
import { endpoint } from '../../utils/api';
//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faUpload } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFolderOpen,faUpload)
const FilesTable = ({files, users}) => {

    const [IDLoading, setIDLoading] = useState("");

    const openFile = async (id) => {
       return Word.run(async (context) => {
        let url = endpoint + "/reports/open/" + id;
        fetch(url, 
          {
            headers: {
               Authorization: 'Bearer '+ localStorage.token
           }
          }).then(async function (response) {
            response.json().then(async function (data) {
            let text = Buffer.from(data.file, "hex").toString("base64");
            context.application.createDocument(text).open();            
            setIDLoading("");
            return context.sync();
          });
        });
      });
        
    }

    return (
        <Table striped bordered hover>
        <thead>
            <tr>
            <th className="table-header">Insert</th>
            <th className="table-header">Name</th>
            <th className="table-header">Description</th>
            </tr>
        </thead>
        <tbody>
            {files.map((f) => {
                  return <tr>
                          <td className="align-top">
                              <div style={{width: '100%'}}>
                                    <div style={{display: "inline-block", paddingLeft: '3px', paddingRight: '3px'}}> 
                                      <Button className="primary-button border-button insert-button" size="1x" onClick={() => {openFile(f._id); setIDLoading(f._id)}} disabled={f._id === IDLoading}>
                                          {f._id !== IDLoading ?                                      
                                            <FontAwesomeIcon icon={faFolderOpen}  size='1x' className='all-font-icons' />
                                          :
                                          <Spinner
                                              as="span"
                                              animation="border"
                                              size="sm"
                                              role="status"
                                              aria-hidden="true"
                                              variant="light"
                                          />
                                          }
                                        </Button>
                                      </div>

                              </div>
                          </td>
                          <td>{f.name}</td>
                          <td>{f.description}</td>
                         
  
                      </tr>          
            })}
        </tbody>
        
    </Table>
    
    )
}


export default FilesTable